var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-img-container"},[_c('img',{attrs:{"src":_vm.getImg(_vm.items),"alt":((_vm.items.title) + " - Vocabulary List")},on:{"error":function($event){_vm.items.filename = 'cover.jpg'}}})])}
var staticRenderFns = []

export { render, staticRenderFns }